/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_DropdownInputs */

const en_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Dropdown`)
};

const fr_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le Menu Deroulant`)
};

const de_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropdown-Menü ein-/ausschalten`)
};

const it_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva menu a discesa`)
};

const ru_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить выпадающее меню`)
};

const es_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menú desplegable`)
};

const zh_cn2_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换下拉菜单`)
};

const ja_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップダウンを切り替える`)
};

const hi_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉपडाउन टॉगल करें`)
};

const pt_pt2_toggle_dropdown = /** @type {(inputs: Toggle_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menu suspenso`)
};

/**
* | output |
* | --- |
* | "Toggle Dropdown" |
*
* @param {Toggle_DropdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_dropdown = /** @type {((inputs?: Toggle_DropdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_DropdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toggle_dropdown(inputs)
	if (locale === "de") return de_toggle_dropdown(inputs)
	if (locale === "it") return it_toggle_dropdown(inputs)
	if (locale === "ru") return ru_toggle_dropdown(inputs)
	if (locale === "es") return es_toggle_dropdown(inputs)
	if (locale === "zh-CN") return zh_cn2_toggle_dropdown(inputs)
	if (locale === "ja") return ja_toggle_dropdown(inputs)
	if (locale === "hi") return hi_toggle_dropdown(inputs)
	if (locale === "pt-PT") return pt_pt2_toggle_dropdown(inputs)
	return en_toggle_dropdown(inputs)
});